import { render, staticRenderFns } from "./withdraw-list.vue?vue&type=template&id=564c9c14&scoped=true&"
import script from "./withdraw-list.vue?vue&type=script&lang=js&"
export * from "./withdraw-list.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-list.vue?vue&type=style&index=0&id=564c9c14&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564c9c14",
  null
  
)

export default component.exports